import { CollectionHero, HubTiles } from "@/components/CollectionHero";
import { Reveal } from "@/components/Reveal";
import { AMERICAN_OAK_HUB } from "@/lib/timber";

export default function AmericanOak() {
  return (
    <div data-testid="american-oak-hub">
      <CollectionHero
        crumbs={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection", to: "/collections/timber" },
          { label: "American Oak" },
        ]}
        eyebrow={AMERICAN_OAK_HUB.eyebrow}
        title={AMERICAN_OAK_HUB.title}
        intro={AMERICAN_OAK_HUB.intro}
        heroSlides={AMERICAN_OAK_HUB.heroSlides}
      />

      <section className="edge pb-4 md:pb-8" data-testid="american-oak-body">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-9 md:col-start-4">
            <Reveal>
              <p className="text-base leading-relaxed text-muted-foreground md:text-lg">
                {AMERICAN_OAK_HUB.body}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <HubTiles items={AMERICAN_OAK_HUB.categories} columns="md:grid-cols-2" />
    </div>
  );
}
